import * as React from "react";
const SvgBuilding = (props) => (
  <svg
    width={21}
    height={20}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    {...props}
  >
    <g
      style={{
        mixBlendMode: "multiply",
      }}
    >
      <path
        d="M13.875 8.75a.625.625 0 1 0-1.25 0v1.875a.624.624 0 1 0 1.25 0V8.75Z"
        fill="#121212"
      />
      <path
        d="M10.75 8.125a.625.625 0 0 1 .625.625v1.875a.624.624 0 1 1-1.25 0V8.75a.625.625 0 0 1 .625-.625ZM8.875 8.75a.625.625 0 0 0-1.25 0v1.875a.625.625 0 1 0 1.25 0V8.75ZM5.75 12.5a.625.625 0 0 1 .625.625V15a.625.625 0 1 1-1.25 0v-1.875a.625.625 0 0 1 .625-.625ZM16.375 13.125a.624.624 0 1 0-1.25 0V15a.624.624 0 1 0 1.25 0v-1.875Z"
        fill="#000"
      />
      <path
        d="M10.75 1.25h2.917c.23 0 .417.186.417.417v1.666a.417.417 0 0 1-.417.417h-2.292v.66c2.813.31 5 2.694 5 5.59h1.25a1.875 1.875 0 0 1 1.875 1.875V17.5a.624.624 0 0 1-.625.625H2.625A.625.625 0 0 1 2 17.5v-5.625A1.875 1.875 0 0 1 3.875 10h1.25a5.625 5.625 
0 0 1 5-5.59V1.874a.625.625 0 0 1 .625-.625Zm0 4.375A4.375 4.375 0 0 0 6.375 10v.625a.625.625 0 0 1-.625.625H3.875a.625.625 0 0 0-.625.625v5h5.313V15a.625.625 0 0 1 .624-.625h3.126a.624.624 0 0 1 .624.625v1.875h5.313v-5a.624.624 0 0 0-.625-.625H15.75a.624.624 
0 0 1-.625-.625V10a4.375 4.375 0 0 0-4.375-4.375Zm.938 10H9.812v1.25h1.876v-1.25Z"
        fill="#000"
      />
    </g>
  </svg>
);
export default SvgBuilding;
